import axios from 'axios'

export default new class TestResultService {
  getList (testJobId) {
    return axios.get('/test-results?sort=-timestamp&testId=' + testJobId)
  }
}()
